module.exports = __webpack_public_path__ + "static/sport/swiper-2.424b2b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/swiper-2.png
// module id = ZQ6n
// module chunks = 0